module.exports = __webpack_public_path__ + "static/media/esports-page-grid-5.8be179bb.jpg";